import HttpClient from './HttpClient';
import StrapiClient from './StrapiClient';

const baseURL = process.env.REACT_APP_API_ENDPOINT;
export const strapiBaseURL = process.env.REACT_APP_STRAPI_DEVELOPMENT_URL;

export const httpClient = new HttpClient({ baseURL });
export const strapiClient = new StrapiClient({ baseURL: strapiBaseURL });
